import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material'
import React, { SetStateAction } from 'react'
import DeleteIcon from "@mui/icons-material/Delete";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import variables from "../../../assets/styles/variables.module.scss"
import Confirm from '../../Types/Confirm';



interface MyComponentProps {
    details: Confirm
}



const ConfirmPopup: React.FC<MyComponentProps> = (props) => {
    const { show, setConfirmPopupData, title, info, varient, functionName, functionParam } = props.details
    const handleClose = () => {
        if (setConfirmPopupData) {
            setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
        }
    };
    return (
        <Dialog
            open={show}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                "& .MuiDialog-paper": {
                    width: "380px", // Customize width
                    maxWidth: "100%", // Ensure responsiveness
                },
            }}
        >
            <DialogContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        width: "56px",
                        height: "56px",
                        borderRadius: "50%",
                        background: varient && varient === "delete" ? variables.mainRedLight : variables.enterpriseColorLight,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {/* pop up varient based icon */}
                    {varient === "delete" && <DeleteIcon sx={{ color: variables.mainRed, fontSize: 30 }} />}
                    {varient !== "delete" && <TaskAltIcon sx={{ color: 'primary', fontSize: 30 }} />}
                </Box>
                <Typography variant="body1">{title}</Typography>
                <DialogContentText variant="body2" id="alert-dialog-description" align="center">
                    {info}
                </DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    display: "flex",
                    gap: 2,
                    px: 3,
                    pb: 3,
                }}
            >
                <Button
                    fullWidth
                    variant="outlined"
                    disableElevation
                    onClick={handleClose}
                    sx={{
                        textTransform: "capitalize",
                    }}
                >
                    Cancel
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    onClick={() => functionParam ? functionName(functionParam) : functionName()}
                    autoFocus
                    //  {/* pop up varient based color  */}
                    color={varient === "delete" ? "error" : "primary"}
                    sx={{
                        textTransform: "capitalize",
                    }}
                >
                    {/* pop up varient based button  */}
                    {varient === "delete" ? "Delete" : "Confirm"}

                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmPopup